import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature, FEATURE_AUTOMATIONS} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "AutomationsModule"
const debug = false

    // <img width="370" src="/app/web/skin/common/tour/table/start-tour-preview.png">
    // <img width="370" src="/app/web/skin/common/tour/list/list-plate-start.png">
// https://www.goodday.work/app/web/skin/common/tour/list/list-plate-start.png
// https://www.goodday.work/app/web/skin/common/tour/table/start-tour-preview.png

export class AutomationsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.AUTOMATIONS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Automations"
        this.description                = "The Automations module is a powerful tool that helps streamline workflow processes by automating routine tasks and actions. By creating custom sequences triggered by specific events or conditions, users can save time, boost productivity, and increase efficiency for the entire team."
        this.svgIcon                    = "isvg-automations"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Automations"
        this.settingsUrl                = "settings/automations"
        this.parentSection              = SettingsParentSection.AUTOMATIONS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.AUTOMATIONS
        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}